class CustomSliderBlog extends HTMLElement {
	constructor() {
		super();

		this.uniqueClass = `.splide--${this.dataset.id}`;
		this.init();
	}

	init() {
		new Splide(this.uniqueClass, {
			type: 'loop',
			perPage: 3,
			speed: 500,
			arrows: true,
			pagination: false,
			arrowPath:
				'M35.94,21.42a.92.92,0,0,0,0-1.27l-5.73-5.73a.91.91,0,0,0-1.28,0,.9.9,0,0,0,0,1.27L34,20.78l-5.1,5.1a.89.89,0,0,0,.12,1.26.91.91,0,0,0,1.16,0Zm-32.13.26h31.5v-1.8H3.81Z',
			breakpoints: {
				1000: {
					perPage: 2,
				},
				767: {
					perPage: 1,
				},
			},
		}).mount();
	}
}
customElements.define('slider-blog', CustomSliderBlog);
